import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Apolono, sunvizaĝa dio, Febo, ĵetas siajn orajn sagojn malsupren. 
      Tie, kie tiuj sagoj eniĝas en la Teron, pro la renkonto de la suna lumo kaj varmo kun frisko de akvo kaj fekundo de la grundo naskiĝas floroj.
    </p>

    <p class="mb-3">
      Kaj tiam oni diras: Apolono kursekvis Dafnan, kaj ŝi alitransformiĝis en laŭron; Driopan – kaj ŝi fariĝis svelta poplo. 
      Pajno postkuris Siringan – kaj aperis belfloranta siringo… Ankaŭ Hiacinto, Cipreso estas kunligitaj kun Apolono. 
      Kaj la diino de amo kaj beleco Afrodita rilatas al apero de rozo, de anemono kaj adonido. 
      Papavo naskiĝis el sangaj larmoj de Afrodita pro pereinta Adoniso. 
    </p>
    
    <p class="mb-3">
      Lilioj aperis el la lakto de Hera. 
      Trikoloreto ekkreskis pro deziro de Zeŭso krei nutraĵon por kompatinda nimfo Io, alitransformita en bovinon. 
      Kaj nimfeo estis iam bela nimfo, pereinta pro neglekto de indiferenta al ŝi Heraklo.
    </p>
    
    <p class="mb-3">
      Multaj floroj servis kiel kuraciloj por homoj kaj dioj: primolo ĝenerale estis panaceo (ĉionkuracilo) por la dioj de Olimpo. 
      Per cejano la centaŭro Kirono kuracis la vundojn de Heraklo. 
      Kaj la vundojn, kiujn Heraklo mem faris al la dio de subtera mondo Hadeso, kuracis Peoneo, la plej bona lernanto de la dio de medicino Asklepio. 
      Enviante, Asklepio volis venenigi Peoneon; sed Hadeso savis lin, transforminte en pompan floron peonion.
    </p>
    
    <p class="mb-5">
      El alia mitologio: la nimfo Belides prenis formon de lekanto por eviti brakumojn de olda dio Vertumno.
    </p>
    
    <p class="mb-3">
      La floroj estas esprimo de la amo de dioj.
    </p>
    `
  )
}

const itemName = {
  esp: 'Lirika botaniko'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp
  }
}

export default item;